/**
 * Etiquette — le petit titre en capitales espacées (lot « surfaces », 01-11-2026) : celui d'une
 * section (« Prochain shift »), d'une colonne, d'un champ. UNE recette, `.ch-etiquette` de
 * champs.css (Aeonik Fono, 10,5 px, capitales, gris), à la place des mille `uppercase tracking-*`
 * écrits à la main au cockpit.
 *
 *   <Etiquette>Prochain shift</Etiquette>
 *   <Etiquette icone={<Clock />} compte={205}>Comptes</Etiquette>
 *   <Etiquette as="h3">…</Etiquette>            la balise, pour la hiérarchie d'un écran
 */
import type { ReactNode } from "react";

import { cn } from "./utils";
import "./champs.css";
import "./surfaces.css";

export interface EtiquetteProps {
  children: ReactNode;
  icone?: ReactNode;
  /** Un nombre après le mot, en gris : « Comptes 205 ». */
  compte?: number | string;
  /** La balise. Défaut `span`. */
  as?: "span" | "div" | "h2" | "h3" | "h4" | "label";
  htmlFor?: string;
  className?: string;
}

export function Etiquette({ children, icone, compte, as: Balise = "span", htmlFor, className }: EtiquetteProps) {
  return (
    <Balise className={cn("ch-etiquette sf-etiquette", className)} htmlFor={Balise === "label" ? htmlFor : undefined}>
      {icone !== undefined && icone !== null && <span className="sf-etiquette-icone flex">{icone}</span>}
      <span className="truncate">{children}</span>
      {compte !== undefined && <span className="sf-etiquette-compte">{compte}</span>}
    </Balise>
  );
}
